import { FC } from 'react'

import { useNavigate } from 'react-router-dom'

import { SequenceMenu } from '@sequencehq/core-components'

import { automationsPaths } from 'Automations/router'

export const ViewWorkflowHistoryMenuItem: FC<{
  onClick?: () => void
}> = ({ onClick }) => {
  const navigate = useNavigate()

  return (
    <SequenceMenu.Item
      uuid="view-workflow-history"
      label="View workflow history"
      data-testid="automations.management.menuItem.viewWorkflowHistory"
      onClick={() => {
        navigate(automationsPaths.executionHistory())
        onClick?.()
      }}
    />
  )
}
